import { SocialLink } from 'shared/interfaces';
import { SOCIAL_NETWORK_ICONS } from './social-network-icons';

export const SOCIAL_LINKS: SocialLink[] = [
  {
    label: 'Twitter',
    icon: SOCIAL_NETWORK_ICONS.twitter,
    link: 'https://twitter.com/Ok_LetsPlay',
  },
  {
    label: 'Telegram',
    icon: SOCIAL_NETWORK_ICONS.telegram,
    link: 'https://t.me/ok_letsplay',
  },
  {
    label: 'Discord',
    icon: SOCIAL_NETWORK_ICONS.discord,
    link: 'https://discord.gg/3M4EUSY',
  },
  {
    label: 'Medium',
    icon: SOCIAL_NETWORK_ICONS.medium,
    link: 'https://medium.com/@okletsplay',
  },
  {
    label: 'Facebook',
    icon: SOCIAL_NETWORK_ICONS.facebook,
    link: 'https://www.facebook.com/OkLetsPlayOfficial',
  },
  {
    label: 'Instagram',
    icon: SOCIAL_NETWORK_ICONS.instagram,
    link: 'https://www.instagram.com/okletsplay_official/',
  },
];
